
export enum StepEventType 
{
    Invoice = "Invoice",
    PersonalPickup = "PersonalPickup",
    PackageToCustomer = "PackageToCustomer",
    Training = "Training",
    PersonalReturn = "PersonalReturn",
    PackageFromCustomer = "PackageFromCustomer",
    PaymentReturn = "PaymentReturn",
    ManaPostalDelivery = "ManaPostalDelivery",
    AddToBasket = "AddToBasket",
    Payment = "Payment",
    Event = "Event",
}

export class StepEvent
{
    constructor(
        public Type: StepEventType,
        public OrderId: string,
        public Icon: string,
        public Label: string,
        public Date: Date,
        public IsDone: boolean,
        public IsVisibleForCustomer: boolean = true
    ) { }
}
